import { cn } from "../../utils/helpers";

interface SkeletonProps {
    /** Test id for selecting container in test environment */
    containerTestId?: string;
    /** Class for styling skeleton */
    className?: string;
    /**
     * Skeleton type
     * Default type is the block loader
     * */
    type?: "table" | "document";
    /** Skeleton height */
    height?: string | number;
    /** Skeleton width */
    width?: string | number;
    /** Determines if skeleton should be rounded */
    isRounded?: boolean;
    /** Amount of skeleton shown
     * For table skeleton this is the amount of table data to show
     * For block skeleton (default) this will be the amount of block
     *   skeleton to show
     */
    count?: number;
}

export default function Skeleton({
    containerTestId,
    height,
    width,
    className,
    type,
    count,
    isRounded,
}: SkeletonProps) {
    switch (type) {
        case "table":
            return (
                <div
                    data-testid={containerTestId}
                    className={cn(
                        "flex flex-col rounded-r8 bg-white border border-strokelight",
                        className
                    )}
                >
                    <div className=" flex flex-col gap-y-[1px]">
                        {[...new Array(count || 8)].map((item) => (
                            <div
                                key={item}
                                className={cn(
                                    " w-full h-40 bg-[rgba(0,0,0,0.03)]  first:rounded-tr-r8 first:rounded-tl-r8",
                                    " animate-pulseBg"
                                )}
                            />
                        ))}
                    </div>
                    <div className=" flex justify-between rounded-bl-r8 rounded-br-r8 h-40 mt-[2px] items-center px-6">
                        <span className=" h-[3rem] bg-[rgba(0,0,0,0.03)] w-1/5 animate-pulseBg " />
                        <span className="h-[3rem] bg-[rgba(0,0,0,0.03)] w-1/5 animate-pulseBg" />
                    </div>
                </div>
            );

        default:
            return (
                <>
                    {[...new Array(count || 1)].map((item) => (
                        <span
                            key={item}
                            style={{ height, width }}
                            data-testid={containerTestId || ""}
                            className={cn(
                                " inline-block h-20 w-auto",
                                " animate-pulseBg",
                                className,
                                {
                                    " rounded-full": isRounded,
                                    "[&:not(:first-child)]:mt-10": count,
                                }
                            )}
                        />
                    ))}
                </>
            );
    }
}
